<template>
    <div>
        <b-tabs>
        <b-tab active>
            <template slot="title">
                <h6>Pagar Caja</h6>
            </template>
            <template>
                <orden-pago-caja></orden-pago-caja>
            </template>
        </b-tab>
        <b-tab>
            <template slot="title">
                <h6>OP Pagadas</h6>
            </template>
            <template>
                <o-p-emitidas></o-p-emitidas>
            </template>
        </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import OrdenPagoCaja from '@/components/ordenpago/OrdenPagoCaja'
import OPEmitidas from '@/components/ordenpago/OPEmitidas'      
export default {
 components:{
     OrdenPagoCaja,
     OPEmitidas
 }
}
</script>